






import vue from "vue";
import ExerciseHtmlText from "@tt-app/components/exercise/consolidated/exercise/body/ExerciseHtmlText.vue";

interface Computed {
  concatenatedBody: string;
}

interface Props {
  body: string | string[];
  template: number;
}

export default vue.extend<any, any, Computed, Props>({
  name: "ListeningHtmlText",

  components: { ExerciseHtmlText },

  computed: {
    concatenatedBody() {
      if (Array.isArray(this.body)) {
        return this.body.join("\n");
      }

      return this.body;
    }
  },

  props: {
    body: {
      type: [String, Array],
      default: undefined
    },
    template: {
      type: Number,
      default: 0
    }
  }
});
